import React from "react";

const sentimentMap = {
  positive: "text-emerald-400 border-emerald-400/30",
  negative: "text-[#FF3B30] border-[#FF3B30]/40",
  neutral: "text-zinc-300 border-white/20",
};

export function SentimentBadge({ value }) {
  const key = String(value || "neutral").toLowerCase();
  const cls = sentimentMap[key] || sentimentMap.neutral;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest border ${cls}`}>
      {key}
    </span>
  );
}

export function IntentScore({ score }) {
  const n = Number(score || 0);
  const hi = n >= 0.75;
  const mid = n >= 0.5 && n < 0.75;
  const color = hi ? "text-[#FF3B30] border-[#FF3B30]" : mid ? "text-amber-400 border-amber-400/50" : "text-zinc-400 border-white/15";
  return (
    <div className={`inline-flex items-center gap-2 border px-2 py-0.5 font-mono text-[11px] ${color}`}>
      <span className="uppercase tracking-widest">INTENT</span>
      <span className="text-sm">{n.toFixed(2)}</span>
    </div>
  );
}

const statusMap = {
  Pending: "bg-[#FF3B30] text-white",
  Orchestrating: "bg-amber-500 text-black",
  Active: "bg-emerald-500 text-black",
  Completed: "bg-white text-black",
  Archived: "bg-zinc-800 text-zinc-400",
  Draft: "bg-zinc-700 text-zinc-200",
  "Awaiting Execution": "bg-[#007AFF] text-white",
  "Verification Failed": "bg-[#FF3B30] text-white",
  Verifying: "bg-amber-500 text-black",
};
export function StatusBadge({ status }) {
  const cls = statusMap[status] || "bg-zinc-700 text-zinc-200";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest ${cls}`}>
      {status}
    </span>
  );
}

const personaColors = {
  Agitator: "text-amber-300 border-amber-400/40",
  Advocate: "text-cyan-300 border-cyan-400/40",
  Closer: "text-[#FF3B30] border-[#FF3B30]/50",
  Standardizer: "text-zinc-300 border-white/20",
};
export function PersonaBadge({ persona }) {
  const cls = personaColors[persona] || "text-zinc-300 border-white/20";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest border ${cls}`}>
      {persona}
    </span>
  );
}
